import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import SimpleBar from "simplebar-react/dist"
import { Card, CardBody, TabContent, TabPane, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import axios from "axios"
import config from "config/config"
import { useSelector } from "react-redux"
import Spinners from "components/Common/Spinner"
import UserJPG from "../../assets/images/user.jpg"
import SnackbarComponent from "components/SnackBar"

const CustomerDetails = props => {
  document.title = "Facebook Post Insights"

  const breadcrumbItems = [
    { title: "Dashboard", link: "#" },
    { title: "Facebook", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Post Details", breadcrumbItems)
  })

  const [isLoading, setLoading] = useState(false)
  const [currentActiveTab, setCurrentActiveTab] = useState("Details")
  const formatDate = dateString => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }
    return new Date(dateString).toLocaleString(undefined, options)
  }
  const [activeTab, setactiveTab] = useState("1")
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [post, setPost] = useState(null)
  const mode = useSelector(state => state.Layout.layoutMode)
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const fetchPost = async () => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${props.postId}`,
        {
          params: {
            fields:
              "id,message,created_time,attachments{media_type,media,url},reactions.limit(100){type,name},comments.limit(100){message,created_time,from,name}",
            access_token: activeOrganization.InstagramIntegrations[0].pageToken,
          },
        },
      )

      const postData = response.data

      const processedComments = postData.comments?.data.map(comment => ({
        ...comment,
        from: comment.from || { name: "Facebook User (Private)" },
      }))

      setPost({
        ...postData,
        comments: { data: processedComments },
      })
    } catch (err) {
      console.error("Error fetching post details:", err)
      setErr("Error fetching post data. Please try again.")
    }
  }

  const [replyIndex, setReplyIndex] = useState(null)
  const [replies, setReplies] = useState({})
  const [currentCommentId, setCurrentCommentId] = useState(null)
  const accessToken = activeOrganization.InstagramIntegrations[0].pageToken

  const handleReplyClick = (index, commentId) => {
    setReplyIndex(index === replyIndex ? null : index)
    setCurrentCommentId(commentId)
  }

  const handleReplyChange = (index, value) => {
    setReplies({ ...replies, [index]: value })
  }

  const handleReplySubmit = async index => {
    const message = replies[index]
    const commentId = currentCommentId

    if (!message || !commentId) {
      props.setErr("Something is missing.")
    }

    try {
      const response = await axios.post(
        `https://graph.facebook.com/v20.0/${commentId}/comments`,
        { message },
        {
          headers: {
            Authorization: `Bearer ${activeOrganization.InstagramIntegrations[0].pageToken}`,
          },
        },
      )
      console.log("Reply sent:", response.data)
      setReplies({ ...replies, [index]: "" })
      setReplyIndex(null)
      props.setSuccess("Replied to comment successfully")
    } catch (error) {
      console.error("Error sending reply:", error)
      props.setErr("Reply to comment failed")
    }
  }

  useEffect(() => {
    fetchPost()
  }, [])

  const scroollRef = useRef(null)

  return (
    <React.Fragment>
      <div
        className="d-lg-flex"
        style={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <SnackbarComponent
          err={err}
          success={success}
          setErr={setErr}
          setSuccess={setSuccess}
        />
        {post && (
          <Card className="chat-leftsidebar br">
            <CardBody style={{ maxHeight: "fit-content", overflow: "hidden" }}>
              <div className="text-center bg-light rounded px-4 py-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="text-start">
                    <span
                      className="mdi mdi-arrow-left"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        props.setSelectedPost(null)
                        props.setPostClicked(false)
                      }}
                    ></span>
                  </div>
                </div>
                <div className="chat-user-status">
                  <img
                    style={{
                      objectFit: "cover",
                    }}
                    src={post.attachments.data[0].media.image.src || UserJPG}
                    className="avatar-md rounded-circle"
                    alt=""
                  />
                </div>
                <h5 className="font-size-14 mb-1 mt-3">{post.id}</h5>
                <p className="text-muted mb-0">
                  {formatDate(post.created_time)}
                </p>
              </div>
            </CardBody>
            {isLoading ? (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: "100%" }}
              >
                <Spinners
                  setLoading={setLoading}
                  style={{
                    color: mode === "dark" ? "#fff" : "#2990DF",
                  }}
                />
              </div>
            ) : (
              <div className="chat-leftsidebar-nav">
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <div
                      className="chat-message-list"
                      style={{ height: "100%" }}
                    >
                      <ul
                        className="list-unstyled chat-list p-3"
                        style={{ height: "100%" }}
                      >
                        <div style={{
                        }}>
                          {["Details", "Comments"].map(tabName => {
                            const isActive = currentActiveTab === tabName

                            // 🎨 Theme-aware colors
                            const backgroundColor = isActive
                              ? "#2990DF"
                              : mode === "dark"
                                ? "transparent" // dark gray background for dark mode
                                : "transparent"

                            const titleColor = isActive
                              ? "#fff"
                              : mode === "dark"
                                ? "#e2e8f0" // text color for dark mode
                                : "#000" // text color for light mode

                            const subtitleColor = isActive
                              ? "#f1f5f9"
                              : mode === "dark"
                                ? "#94a3b8" // lighter gray for dark mode
                                : "#6b7280" // muted gray for light mode

                            return (
                              <li
                                key={tabName}
                                className={isActive ? "active" : ""}
                                style={{
                                  backgroundColor,
                                  borderRadius: "8px",
                                  transition: "background-color 0.2s ease",
                                }}
                                // optional hover (makes UX nicer)
                                onMouseEnter={e => {
                                  if (!isActive)
                                    e.currentTarget.style.backgroundColor =
                                      mode === "dark" ? "#334155" : "#f1f5f9"
                                }}
                                onMouseLeave={e => {
                                  if (!isActive)
                                    e.currentTarget.style.backgroundColor =
                                      mode === "dark"
                                        ? "#1e293b"
                                        : "transparent"
                                }}
                              >
                                <Link
                                  to="#"
                                  onClick={() => setCurrentActiveTab(tabName)}
                                  style={{
                                    color: isActive ? "#fff" : "inherit",
                                    display: "block",
                                    padding: "10px 12px",
                                    textDecoration: "none",
                                  }}
                                >
                                  <div className="d-flex align-items-center mt-2">
                                    <div className="flex-grow-1 overflow-hidden">
                                      <h5
                                        className="text-truncate font-size-15 mb-0"
                                        style={{ color: titleColor }}
                                      >
                                        {tabName}
                                      </h5>
                                      <p
                                        className="text-muted mb-0 mt-1 text-truncate"
                                        style={{ color: subtitleColor }}
                                      >
                                        {tabName === "Details"
                                          ? "Select to display details of post"
                                          : "Select to display post comments"}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              </li>
                            )
                          })}
                        </div>
                      </ul>
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            )}
          </Card>
        )}

        <div
          className="user-chat mt-4 mt-sm-0 ms-lg-3"
          style={{
            flex: 1,
            height: "600px",
            maxWidth: "100%",
            overflow: "auto",
          }}
        >
          <Card className="br">
            <div className="p-3 px-lg-4 border-bottom">
              <Row className="align-items-center">
                <Col
                  xs={12}
                  className="d-flex align-items-center justify-content-between"
                >
                  <h4 className="mt-2 text-truncate flex-grow-1">
                    {currentActiveTab}
                  </h4>
                </Col>
              </Row>
            </div>

            <SimpleBar
              ref={scroollRef}
              className="chat-conversation p-4 "
              style={{
                height: "500px",
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
              }}
            >
              {isLoading ? (
                <Spinners
                  setLoading={setLoading}
                  style={{
                    color: mode === "dark" ? "#ffffff" : "#2990DF",
                  }}
                />
              ) : currentActiveTab === "Details" && post ? (
                <div
                  style={{
                    maxWidth: "100%",
                  }}
                >
                  <h5>Caption:</h5>
                  <p style={{ wordBreak: "break-word" }}>
                    {post.message || "No caption available"}
                  </p>

                  <h5>Media:</h5>
                  {post.attachments?.data?.map((attachment, index) => (
                    <div key={index} style={{ marginBottom: "1rem" }}>
                      {attachment.media_type === "photo" && (
                        <img
                          src={attachment.media.image.src}
                          alt="Post Media"
                          style={{ width: "50%", borderRadius: "8px" }}
                        />
                      )}
                      {attachment.media_type === "video" && (
                        <video
                          src={attachment.media.source}
                          controls
                          style={{ width: "50%", borderRadius: "8px" }}
                        />
                      )}
                    </div>
                  ))}

                  <h5>Likes: ({post.reactions?.data?.length})</h5>
                  {post.reactions?.data?.length > 0 ? (
                    <ul>
                      {post.reactions.data.map((reaction, index) => (
                        <li key={index}>
                          {reaction.name} ({reaction.type})
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No reactions available</p>
                  )}
                </div>
              ) : currentActiveTab === "Comments" &&
                post?.comments?.data?.length > 0 ? (
                <div>
                  <h5>Comments:</h5>
                  <ul className="list-unstyled">
                    {post.comments.data.map((comment, index) => (
                      <li key={index} style={{ marginBottom: "1.5rem" }}>
                        <div className="d-flex align-items-start">
                          <img
                            src={UserJPG}
                            alt="User Avatar"
                            className="avatar-xs rounded-circle me-3"
                          />
                          <div>
                            {comment?.from?.name ? (
                              <h6 className="mb-1">{comment?.from.name}</h6>
                            ) : (
                              <h6 className="mb-1">Facebook User (Private)</h6>
                            )}
                            <p
                              className="mb-1"
                              style={{ wordBreak: "break-word" }}
                            >
                              {comment.message}
                            </p>
                            <small className="text-muted">
                              {formatDate(comment.created_time)}
                            </small>

                            <div className="mt-2">
                              <button
                                className="btn btn-link text-primary p-0"
                                onClick={() =>
                                  handleReplyClick(index, comment.id)
                                }
                              >
                                Reply
                              </button>
                            </div>

                            {replyIndex === index && (
                              <div className="mt-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Write a reply..."
                                  value={replies[index] || ""}
                                  onChange={e =>
                                    handleReplyChange(index, e.target.value)
                                  }
                                />
                                <button
                                  className="btn btn-primary mt-2"
                                  onClick={() => handleReplySubmit(index)}
                                >
                                  Submit Reply
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p>No comments available</p>
              )}
            </SimpleBar>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(CustomerDetails)
